import { openModal } from '@core/components/ModalStack';
import { AddEditTaskStatusModalProps } from './AddEditTaskStatusModal';

export async function openAddEditTaskStatus(props: AddEditTaskStatusModalProps) {
  const { AddEditTaskStatusModal } = await import('./AddEditTaskStatusModal');

  openModal(AddEditTaskStatusModal, props);
}
